import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  backButtonTarget: "loginOrRegister",
  conNumber: "",
  content: "loginOrRegister",
  email: "",
  password: "",
  isTwoFactorEnabled: false,
  isAmpliLoaded: false,
  isEmailNotSent: false,
  isPermanentlyLocked: false,
  isResetPassword: false,
  isTemporaryLocked: false,
  token: "",
  redirectUrl: "",
};

const applicationSlice = createSlice({
  name: "APPLICATION",
  initialState,
  reducers: {
    setAmpliLoaded: (state, action) => {
      state.isAmpliLoaded = action.payload;
    },
    setBackButtonTarget: (state, action) => {
      state.backButtonTarget = action.payload;
    },
    setCON: (state, action) => {
      state.conNumber = action.payload;
    },
    setContent: (state, action) => {
      state.content = action.payload;
    },
    setEmailAddress: (state, action) => {
      state.email = action.payload;
    },
    setPasswordForTwoFactor: (state, action) => {
      state.password = action.payload;
    },
    setTwoFactorEnabled: (state, action) => {
      state.isTwoFactorEnabled = action.payload;
    },
    setEmailNotSent: (state, action) => {
      state.isEmailNotSent = action.payload;
    },
    setPermanentlyLocked: (state, action) => {
      state.isPermanentlyLocked = action.payload;
    },
    setResetPassword: (state, action) => {
      state.isResetPassword = action.payload;
    },
    setTemporaryLocked: (state, action) => {
      state.isTemporaryLocked = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },
  },
});

export const {
  setAmpliLoaded,
  setBackButtonTarget,
  setCON,
  setContent,
  setEmailAddress,
  setPasswordForTwoFactor,
  setTwoFactorEnabled,
  setEmailNotSent,
  setPermanentlyLocked,
  setResetPassword,
  setTemporaryLocked,
  setToken,
  setRedirectUrl,
} = applicationSlice.actions;

export default applicationSlice.reducer;
